
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 84.2 86.8"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentColor","d":"M73.8 22.1l4.1 4c1.1 1.1 2.1 2.2 3 3.5 1.1 1.6 2 3.4 2.4 5 .6 1.7.9 3.5.9 5.4 0 4.9-2.1 9.3-5.5 12.4-1.3 1.2-1.3 3 0 4.2 1.2 1.1 2.3 2.6 3.2 4.1.2.3.4.7.6 1 1.1 2.2 1.8 4.8 1.8 7.5 0 1.6-.2 3.1-.7 4.6-.4 1.6-1 3.1-1.9 4.6-1.6 2.6-3.7 4.7-6.4 6.2s-5.7 2.3-8.9 2.3H32.7c-2 0-3.9-.8-5.3-2.2L2.2 59.4C.8 58 0 56.1 0 54.1V3.8C0 1.7 1.7.1 3.7.1h27.8c2.1 0 3.7 1.7 3.7 3.7v40.3c0 3.5-2.9 6.3-6.4 6.3-3.4-.1-6.1-3.1-6.1-6.5v-2.4c0-1.8-1.5-3.3-3.3-3.3h-5.7c-1.8 0-3.3 1.5-3.3 3.3v2.9l.1 2.2s.4 6.7 4.7 10.7c3 2.8 7.7 5.5 12.8 5.7h1.6c4.8 0 8.8-1.5 12-3.9 1-.7 1.9-1.6 2.6-2.6 1.1-1.4 2-3 2.6-4.8 1.6-4.9 1.4-11.9 1.4-11.9V2.4c0-2.1 2.6-3.2 4.1-1.7l21.5 21.4z"}})])
          )
        }
      }
    